"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var TextArea = _styledComponents["default"].textarea.attrs(function () {
  return {
    className: "form-control",
    name: "best-text-area"
  };
}).withConfig({
  displayName: "TextArea",
  componentId: "sc-1p0hjc4-0"
})(["&&&{::placeholder{color:", " !important;font-weight:", " !important;opacity:1 !important;font-style:italic !important;}:focus{background-color:", ";}", ";", ";border:1px solid ", ";&.form-control.is-invalid{border:1px solid ", ";background:none;}}"], function (props) {
  return props.theme.placeholder["color"];
}, function (props) {
  return props.theme.placeholder["fontWeight"];
}, function (props) {
  return props.theme["focus-color"];
}, function (props) {
  return props.disabled ? "background-color: " + props.theme["light-grey"] + ";" : "";
}, function (props) {
  return props.disabled ? "color: " + props.theme["grey"] + ";" : "";
}, function (props) {
  return props.theme["grey"];
}, function (props) {
  return props.theme["mlb-red"];
});
var _default = TextArea;
exports["default"] = _default;